





















































import dialog from '@/dialog/Dialog.vue'
import textfield from '@/form/Textfield.vue'
import textarea from '@/form/Textarea.vue'
import radiobutton from '@/form/RadioButton.vue'
import checkbox from '@/form/Checkbox.vue'
import selectfield from '@/form/Selectfield.vue'
import multi_checkbox from '@/form/MultiCheckbox.vue'

import { mapState } from 'vuex'


export default {
  name: 'PropertyAddDialog'

  props: [
    'id'
    'group'
    'types'
  ]

  data: () ->
    p: 
      uid: null
      name: null
      label: null
      description: null
      type: null
      is_active: true
      client_property_group_id: null
    options: null
    show_error: false
    # errors: null

  components:
    'v-dialog': dialog
    'v-textfield': textfield
    'v-textarea': textarea
    'v-radiobutton': radiobutton
    'v-checkbox': checkbox
    'v-multi_checkbox': multi_checkbox
    'v-selectfield': selectfield

  methods:
    ok: () ->
      @p.client_property_group_id = @group.uid
      @p.sortorder = @group.getEmbeds('client_property_definitions').length
      @$emit 'ok', @p
    cancel: () -> 
      @$emit 'cancel', false
    set: (a, b) -> 
      @p[a] = b

    reset: () ->
      @p =
        uid: null
        name: null
        label: null
        description: null
        type: null
        is_active: true
        client_property_group_id: null
    showErrors: ($event) ->
      @errors = $event
      @show_error = true

  computed:
    mapState
      show: (state) ->
        state.dialog
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/dialog/PropertyAdd.vue